/**
 * 即時連線是否健康：連線本身是 connected，且盤面倚賴的每個頻道都已 attached。
 *
 * 任一條件不成立就視為不健康——盤面收不到 delta 事件，畫面會停在最後一次同步的狀態。
 * 未知或缺席的狀態一律判為不健康（防禦性預設）。
 *
 * @param {string} [connectionState] Ably connection.state
 * @param {string[]} [channelStates] 盤面倚賴的各頻道 channel.state
 * @returns {boolean}
 */
export function isRealtimeHealthy(connectionState, channelStates) {
    if (connectionState !== 'connected') {
        return false;
    }
    if (!Array.isArray(channelStates) || channelStates.length === 0) {
        return false;
    }
    return channelStates.every((state) => state === 'attached');
}

/**
 * 斷線橫幅的顯示閘門：恢復立刻生效，斷線要撐過寬限期才顯示。
 *
 * 頁面載入當下連線必然還沒 attach 完（`channels.get()` 之後的 attach 是非同步的），
 * Ably 自癒的瞬斷也會經過 `connecting`——沒有寬限期的話橫幅會在每次正常載入與每次瞬斷
 * 閃一次紅字，使用者很快就學會忽略它，真的斷線時它不再是訊號。
 *
 * 心跳不走這道閘門：多跑一次重抓無害，誤報橫幅有害。
 *
 * @param {{
 *   schedule: function(function(): void, number): *,
 *   cancel: function(*): void,
 *   graceMs: number,
 *   onChange: function(boolean): void,
 * }} deps
 * @returns {{update: function(boolean): void}}
 */
export function createRealtimeNoticeGate({ schedule, cancel, graceMs, onChange }) {
    let visible = false;
    let pendingId;

    function update(healthy) {
        if (healthy) {
            if (pendingId !== undefined) {
                cancel(pendingId);
                pendingId = undefined;
            }
            if (visible) {
                visible = false;
                onChange(false);
            }
            return;
        }

        if (visible || pendingId !== undefined) {
            return;
        }
        pendingId = schedule(() => {
            pendingId = undefined;
            visible = true;
            onChange(true);
        }, graceMs);
    }

    return { update };
}
